// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f748917c","239":"ec21a230","455":"694fd2e4","488":"bc1aacef"}[chunkId] + ".chunk.js";
};